import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { consultoriaService } from '../../mocks/services';
import SchemaOrg from '../../components/base/SchemaOrg';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const consultoriaSchema = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'Consultoria em IA para Escolas e Instituições de Ensino',
  description:
    'Consultoria educacional especializada em Inteligência Artificial para escolas, redes de ensino e instituições educacionais que desejam implementar IA de forma ética e pedagógica.',
  url: `${siteUrl}/consultoria`,
  provider: {
    '@type': 'Organization',
    name: 'ViaEducacaoCursos',
    url: siteUrl,
  },
  serviceType: 'Consultoria Educacional em IA',
  inLanguage: 'pt-BR',
  areaServed: 'BR',
  audience: {
    '@type': 'Audience',
    audienceType: 'Escolas e Instituições de Ensino',
  },
};

export default function ConsultoriaPage() {
  return (
    <div className="min-h-screen">
      <SchemaOrg id="consultoria" schema={consultoriaSchema} />
      <Navbar />
      <main>
        <section className="pt-32 pb-20 bg-gradient-to-b from-purple-50 to-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="text-center mb-16">
              <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
                {consultoriaService.title}
              </h1>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                {consultoriaService.subtitle}
              </p>
            </div>

            <div className="mb-20">
              <img
                src={consultoriaService.image}
                alt="Consultoria Educacional"
                className="w-full h-[500px] object-cover rounded-3xl shadow-2xl"
              />
            </div>

            <div className="max-w-4xl mx-auto mb-20">
              <p className="text-xl text-gray-700 leading-relaxed text-center">
                {consultoriaService.description}
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-20">
              {consultoriaService.features.map((feature, index) => (
                <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
                  <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-purple-100 to-blue-100 rounded-2xl mb-6">
                    <i className={`${feature.icon} text-3xl text-purple-600`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {feature.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              ))}
            </div>

            <div className="mb-20">
              <h2 className="text-4xl font-bold text-gray-900 mb-12 text-center">
                Nosso Processo
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                {consultoriaService.process.map((step, index) => (
                  <div key={index} className="relative">
                    <div className="bg-white rounded-2xl p-8 shadow-lg h-full">
                      <div className="text-6xl font-bold text-purple-100 mb-4">
                        {step.step}
                      </div>
                      <h3 className="text-xl font-bold text-gray-900 mb-3">
                        {step.title}
                      </h3>
                      <p className="text-gray-600 leading-relaxed">
                        {step.description}
                      </p>
                    </div>
                    {index < consultoriaService.process.length - 1 && (
                      <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                        <i className="ri-arrow-right-line text-3xl text-purple-300"></i>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-gradient-to-r from-purple-600 to-blue-600 rounded-3xl p-12 text-center text-white">
              <h2 className="text-4xl font-bold mb-6">
                Pronto para transformar sua instituição?
              </h2>
              <p className="text-xl text-purple-100 mb-8 max-w-3xl mx-auto">
                Agende uma reunião sem compromisso para conhecer melhor sua escola e apresentar nossa proposta personalizada
              </p>
              <button
                onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
                className="px-10 py-4 bg-white text-purple-600 font-bold rounded-full hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap"
              >
                Agendar Reunião
              </button>
            </div>
          </div>
        </section>

        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <h2 className="text-4xl font-bold text-gray-900 mb-12 text-center">
              Benefícios da Consultoria
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-20 h-20 flex items-center justify-center bg-purple-100 rounded-full mx-auto mb-6">
                  <i className="ri-line-chart-line text-4xl text-purple-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  Resultados Mensuráveis
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  Acompanhamento de métricas e indicadores para avaliar o impacto da implementação
                </p>
              </div>
              <div className="text-center">
                <div className="w-20 h-20 flex items-center justify-center bg-blue-100 rounded-full mx-auto mb-6">
                  <i className="ri-group-line text-4xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  Engajamento da Equipe
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  Formação completa para garantir que toda equipe esteja preparada e motivada
                </p>
              </div>
              <div className="text-center">
                <div className="w-20 h-20 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-6">
                  <i className="ri-rocket-line text-4xl text-green-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  Inovação Sustentável
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  Implementação gradual e sustentável que se adapta à realidade da sua escola
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}